import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/Api/axiosV2Config';
import type { AuditLog } from '@/features/external-users/types/audit-log.types';

type EntityType = 'internal-user' | 'external-user' | 'society' | 'warranty' | 'contract' | 'general-conditions';

interface UseEntityAuditLogsOptions {
  limit?: number;
  includeDetails?: boolean;
  enabled?: boolean;
}

export const useEntityAuditLogs = (
  entityType: EntityType,
  entityId: string | undefined,
  options: UseEntityAuditLogsOptions = {},
) => {
  const { limit = 100, includeDetails = false, enabled = true } = options;

  const endpoints: Record<EntityType, string> = {
    'internal-user': `/internal-users-v2/${entityId}/audit-logs`,
    'external-user': `/external-users-v2/${entityId}/audit-logs`,
    'society': `/societies/${entityId}/audit-logs`,
    'warranty': `/warranties-admin/${entityId}/audit-logs`,
    'contract': `/pro-v2/contracts/${entityId}/audit-logs`,
    'general-conditions': `/societies/${entityId}/general-conditions/audit-logs`,
  };

  return useQuery<AuditLog[]>({
    queryKey: ['entity-audit-logs', entityType, entityId, limit, includeDetails],
    queryFn: async () => {
      const { data } = await axiosInstance.get<AuditLog[]>(endpoints[entityType], {
        params: { limit, includeDetails },
      });
      return data;
    },
    enabled: enabled && !!entityId,
    staleTime: 10000,
  });
};
